<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea;">
            <h2>{{pageTitle.title}}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{pageTitle.subtitle}}</li>
            </ul>
            <p>{{pageTitle.description}}</p>
        </div>
    </div>

    <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
    <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="faq-area pb-100">
    <div class="container">
        <div class="faq-accordion">
            <ul class="accordion">
                <li class="accordion-item" *ngFor="let Accordion of jobAccordion; index as n">
                    <div (click)="jobSelected(n)">
                        <a class="accordion-title" href="javascript:void(0)">
                            <i class='bx bx-hive'></i>
                            {{Accordion.title}}
                            <i class='bx' [ngClass]="Accordion.isOpen?'bx-chevron-down':'bx-chevron-right'"></i>
                        </a>
                        <div class="accordion-content">
                            <p>{{Accordion.location}}</p>
                        </div>
                        <div class="accordion-content" *ngIf="Accordion.isOpen">
                            <p>{{Accordion.overview}}</p>
                        </div>
                        <div class="accordion-content" *ngIf="Accordion.isOpen">
                            <h6>Key Responsibilities:</h6>
                            <ul *ngFor="let r of Accordion.responsibilities;">
                            <li>{{r}}</li>
                            </ul>
                        </div>
                        <div class="accordion-content" *ngIf="Accordion.isOpen">
                            <h6>Required Skills and Experience:</h6>
                            <ul *ngFor="let e of Accordion.experience;">
                            <li>{{e}}</li>
                            </ul>
                        </div>
                        <div class="accordion-content" *ngIf="Accordion.isOpen">
                            <h6>Preferred Qualifications:</h6>
                            <ul *ngFor="let q of Accordion.qualifications;">
                            <li>{{q}}</li>
                            </ul>
                        </div>
                        <div class="accordion-content" *ngIf="Accordion.isOpen">
                            <p>Join our dynamic team and contribute to cutting-edge projects in a collaborative and innovative environment!</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>